import { Drawer } from '@reveni-io/reveni-ui'

import EmbedSetupContent from './EmbedSetupContent/EmbedSetupContent'
import { embedSetupDrawerOptions } from './constants'

const EmbedSetupDrawer = ({ show, onClose, storeId, storeProvider }) => {
  return (
    <Drawer show={show} onClose={onClose} options={embedSetupDrawerOptions}>
      <EmbedSetupContent storeId={storeId} storeProvider={storeProvider} onClose={onClose} />
    </Drawer>
  )
}

export default EmbedSetupDrawer
